<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h2>Delay/Failure Admin</h2>
    </div>
    <div class="flex-shrink-1">
      <button
        pButton
        class="button ui-button-primary mt-2"
        icon="fa ui-icon-add"
        label="Add Delay/Failure Category"
        (click)="addCategory()"
      ></button>
    </div>
  </div>
</div>

<div class="content-container">
  <p-table
    [value]="delayFailures"
    [responsive]="true"
    resizableColumns="true"
    class="fixed-table"
    selectionMode="none"
    [(selection)]="selectedDelayFailure"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="category">Category</th>
        <th pSortableColumn="emailSubject">Delay Failure Template</th>
        <th pSortableColumn="accountable">Accountable</th>
        <th pSortableColumn="inactiveDate">Inactive Date</th>
        <th pSortableColumn="updatedDate">Updated</th>
        <th pSortableColumn="updatedByUserName">Updated By</th>
        <th style="width: 100px"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <input
            pInputText
            [(ngModel)]="item.category"
            (change)="cellEdit(item)"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
        </td>
        <td>
          <p-dropdown
            [filter]="true"
            appendTo="body"
            placeholder="Select Delay Failure Template"
            [options]="delayFailureTemplateOptions"
            (onChange)="cellEdit(item)"
            [(ngModel)]="item.delayFailureTemplateId"
            autoWidth="false"
            [ngModelOptions]="{ standalone: true }"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </td>
        <td>
          <p-dropdown
            appendTo="body"
            placeholder="Select accountability"
            [options]="accountabilityOptions"
            (onChange)="cellEdit(item)"
            [(ngModel)]="item.accountable"
            autoWidth="false"
            [ngModelOptions]="{ standalone: true }"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </td>
        <td>
          <div pTooltip="This category is inactive" *ngIf="item.inactiveDate" style="width: 100%">
            {{ item.inactiveDate | date : 'dd/MM/yyy HH:mm' }}
          </div>
        </td>
        <td>{{ item.updatedDate | datex : 'ddd DD MMM HH:mm' }}</td>
        <td>{{ item.updatedByUserName }}</td>
        <td>
          <button
            *ngIf="!item.inactiveDate"
            type="button"
            pButton
            (click)="delayFailureActivation(item)"
            icon="fa ui-icon-lock-open"
            pTooltip="Deactivate Category"
          ></button>
          <button
            *ngIf="item.inactiveDate"
            type="button"
            pButton
            (click)="delayFailureActivation(item)"
            icon="fa ui-icon-lock"
            pTooltip="Reactivate Category"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="Add Delay/Failure Category"
  [(visible)]="showAddDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '640px' }"
>
  <form [formGroup]="form" (ngSubmit)="addNewCategory()">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-3">Category Name:</div>
        <div class="ui-g-9">
          <input pInputText formControlName="category" [style]="{ width: '100%' }" />
        </div>
        <div *ngIf="!form.controls['category'].valid" class="error-text">Enter a category name</div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3">Accountability:</div>
        <div class="ui-g-9">
          <p-dropdown
            appendTo="body"
            placeholder="Select accountability"
            [options]="accountabilityOptions"
            formControlName="accountable"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
        <div *ngIf="!form.controls['accountable'].valid" class="error-text">
          Enter valid accountability
        </div>
      </div>
    </div>

    <div style="float: right; margin-top: 50px; padding: 8px">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button-tertiary"
        (click)="showAddDialog = false"
      ></button>

      <button type="submit" class="ui-button-primary" pButton label="Add"></button>
    </div>
  </form>
</p-dialog>
